var ostbv = ostbv || {};

ostbv.formlist = new function () {
  var self = this;

  this.tabs = function(){

      $("body").on("click", '.form-tab-button', function () {
          $(".form-tab-button").removeClass("active"); 
          $(".tab").removeClass("active");
          $(this).addClass("active")
          var thisId = $(this).data("id");
          var tabClass = ".tab" + thisId;
          $(tabClass).addClass("active");
      });
  };

};

